const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import { isPresent } from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
const modalHtml = require("../../sharedHtml/modal.html");
import render from "../../utilities/render";
import { buildExport, prepareDataToSendController, isEdit, doAjax, pushFilterSessionCacheState, isNew, isDeleteView, isOnlyLookupDataUpdate, retriveCriteriaObjectByOperation } from "../../utilities/filtersutil";
import { receivingDiscrepanciesLookupFieldDropdown } from "./filter/receivingDiscrepanciesLookupFieldDropdown.js";
import { actionOptions } from "./filter/actionOptions.js";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../constants";
const _ = require("underscore");
import { photoUploader as photoUploader } from '../../components/fileuploader/index';
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html");
let actionCellDropdownItemTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html");
let actionHeaderDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html");
let actionList = actionOptions;
const uploadDiscrepanciesPhotoModalBodyHtml = require("./html/uploadDiscrepanciesPhotoModalBody.html");
const editDiscrepanciesRecordModalBodyHtml = require("./html/editDiscrepanciesRecordModalBody.html");
const resolvedDiscrepanciesModalBodyHtml = require("./html/resolvedDiscrepanciesModalBody.html");
const deleteDiscrepanciesModalBodyHtml = require("./html/deleteDiscrepancyModalBody.html");

const targetSelector = "#receiving-discrepancies-lookup-outer";
run(targetSelector, () => {
  let discrepanciesPhotoUploadModal = "";
  let resolvedDiscrepanciesModal = "";
  let deleteDiscrepanciesModal = "";
  const entryElement = $(targetSelector);
  const dataTableComponentData = entryElement.data("receiving-discrepancies-lookup-data");
  const getEditRecordURL = $(targetSelector).data("update-form-field-url");
  const uploadPhotosUrl = $(targetSelector).data("upload-photos-url");
  const deleteDiscrepancyUrl = $(targetSelector).data("delete-discrepancy-url");
  const portletNamespace = $(targetSelector).data("portlet-namespace");
  const savedViews = entryElement.data("saved-views");
  const filterSearchUrl = $(targetSelector).data("filter-search-url");
  const saveViewURL = $(targetSelector).data("save-view-url");
  const deleteViewURL = $(targetSelector).data("delete-view-url");
  const backToFormUrl = $(targetSelector).data("reload-form-url");
  const shouldCheckCache = $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");

  const disabledDeleteMessage = "Cannot delete record, as discrepancy is deleted";
  const disabledDeleteCutOffMessage = "Cannot delete record , as cutoff date is passed";
  const disabledDeleteResolvedMessage = "Cannot delete record , as discrepancy is marked resolved";
  const editDisabledResolvedMessage = "Cannot edit record, as discrepancy is marked resolved";
  const editDisabledDeleteMessage = "Cannot edit record, as discrepancy is deleted";
  const disabledImageResolvedMessage = "Cannot upload image, as discrepancy is marked resolved";
  const disabledImageCutOffMessage = "Cannot upload image, as cutOff date is passed";
  const disabledImageDeletedMessage = "Cannot upload image, as discrepancy is deleted";

  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  let exportModal = new buildExport();
  const exportUrl = $(targetSelector).data("export-url");
  let targetObject = "";

  if (shouldCheckCache) {
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
  }

  let receivingDiscrepanciesLookup = new LookupTable({

    target: $("#receiving-discrepancies-lookup-wrapper"),
    minWidthClass: "q-min-width-sm-til-md",
    mobileColumns: [
      {
        data: "redId",
        render: renderActionWrap,
        orderable: false,
        title: "Actions",
        class: "dtc-action-column"
      },
      {
        data: "redPhoto",
        title: "Photo Reqd",
        class: "dtc-min-width-smbn"
      },
      {
        data: "redTrackingNum",
        title: "Tracking#",
        class: "dtc-min-width-sm"
      },
      {
        data: "redPoTrfNum",
        title: "PO/TRF#",
        class: "dtc-min-width-sm"
      },
      {
        data: "redShipidOrderNum",
        title: "ShipId Order#",
        class: "dtc-min-width-sm"
      },
      {
        data: "redSku",
        title: "sku",
        class: "dtc-min-width-sm"
      },
      {
        data: "redItemExistsOnPo",
        title: "Item exists on PO",
        class: "dtc-min-width-smbn"
      },
      {
        data: "redDiscrepancyQty",
        title: "Discrepancy_Qty",
        class: "dtc-min-width-smbn"
      },
      {
        data: "rddDiscrepancyCodeWithDescription",
        title: "DiscrepancyDescription",
        class: "dtc-min-width-md"
      },
      {
        data: "redTransactionDate",
        title: "Transaction Date",
        class: "dtc-min-width-sm"
      },
      {
        data: "redVendorSupplier",
        title: "Vendor-Supplier",
        class: "dtc-min-width-sm"
      },
      {
        data: "redRecordType",
        title: "Record Type",
        class: "dtc-min-width-smbn"
      },
      {
        data: "rddImageUploaded",
        title: "Image Uploaded",
        class: "dtc-min-width-smbn"
      }
    ],

    tableSearch: true,
    // REQUIRED: search input info
    tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: targetObject != "" ? targetObject.value[0] : ""

    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: targetObject == "" ? "" : targetObject.key,
      columns: receivingDiscrepanciesLookupFieldDropdown
    },
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: false,
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [{}],
      // Not required, just to show you can
      order: [[5, 'desc']],
      columns: [
        {
          data: "redId",
          render: renderActionWrap,
          orderable: false,
          title: "Actions",
          class: "dtc-action-column"
        },
        {
          data: "redPhoto",
          title: "Photo Reqd",
          class: "dtc-min-width-smbn"
        },
        {
          data: "redTrackingNum",
          title: "Tracking#",
          class: "dtc-min-width-sm"
        },
        {
          data: "redPoTrfNum",
          title: "PO/TRF#",
          class: "dtc-min-width-sm"
        },
        {
          data: "redShipidOrderNum",
          title: "ShipId Order#",
          class: "dtc-min-width-sm"
        },
        {
          data: "redSku",
          title: "SKU",
          class: "dtc-min-width-sm"
        },
        {
          data: "redItemExistsOnPo",
          title: "Item exists on PO",
          class: "dtc-min-width-smbn"
        },
        {
          data: "redDiscrepancyQty",
          title: "Discrepancy Qty",
          class: "dtc-min-width-smbn"
        },
        {
          data: "rddDiscrepancyCodeWithDescription",
          title: "Discrepancy Code/Description",
          class: "dtc-min-width-md"
        },
        {
          data: "redTransactionDate",
          title: "Transaction Date",
          class: "dtc-min-width-sm"
        },
        {
          data: "redVendorSupplier",
          title: "Vendor-Supplier",
          class: "dtc-min-width-sm"
        },
        {
          data: "redRecordType",
          title: "Record Type",
          class: "dtc-min-width-smbn"
        },
        {
          data: "rddImageUploaded",
          title: "Image Uploaded",
          class: "dtc-min-width-smbn"
        }
      ],
    },
    paginationData: dataTableComponentData.page,

    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Receiving Discrepancies ",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "receivingDiscrepancies"
    },

    onBulkSelectChange: function () {
      const selectedRows = receivingDiscrepanciesLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },

    onFetch: function () {
      let currentData = receivingDiscrepanciesLookup.generateData();
      receivingDiscrepanciesLookup.showLoadingOverlay();
      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
      if (isOnlyLookupDataUpdate(currentData)) {
        setTimeout(() => {
          doAjax({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isNew(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isEdit(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isDeleteView(currentData)) {
        setTimeout(() => {
          doAjax({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
        }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  });

  $("#back-to-form").on("click", function () {
    window.open(backToFormUrl, "_self");
  })

  function filterSuccessFun(data) {
    let receivingDiscrepancies = data.content;
    let page = data.page;
    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
    receivingDiscrepanciesLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    receivingDiscrepanciesLookup.hideLoadingOverlay();
    setExportData(receivingDiscrepanciesLookup.generateData());
  }

  function savedViewSuccess(data) {
    let receivingDiscrepancies = data.lookupRecevingDiscrepancyJSON.content;
    let page = data.lookupRecevingDiscrepancyJSON.page;
    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
    receivingDiscrepanciesLookup.setPaginationData(page);
    receivingDiscrepanciesLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    receivingDiscrepanciesLookup.hideLoadingOverlay();
    setExportData(receivingDiscrepanciesLookup.generateData());
  }

  function savedEditViewSuccess(data) {
    let receivingDiscrepancies = data.lookupRecevingDiscrepancyJSON.content;
    let page = data.lookupRecevingDiscrepancyJSON.page;
    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
    receivingDiscrepanciesLookup.setPaginationData(page);
    receivingDiscrepanciesLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    receivingDiscrepanciesLookup.hideLoadingOverlay();
    setExportData(receivingDiscrepanciesLookup.generateData());
  }

  function delteViewScussFun(data) {
    let receivingDiscrepancies = data.lookupRecevingDiscrepancyJSON.content;
    let page = data.lookupRecevingDiscrepancyJSON.page;
    receivingDiscrepanciesLookup.removeSavedView(data.target);
    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
    receivingDiscrepanciesLookup.setPaginationData(page);
    receivingDiscrepanciesLookup.hideLoadingOverlay();
    setExportData(receivingDiscrepanciesLookup.generateData());
  }

  function errorFun(data) {
    receivingDiscrepanciesLookup.hideLoadingOverlay();
  }

  receivingDiscrepanciesLookup.init();
  function shallAllowClick(currentObj) {
    return !$(currentObj).hasClass("disabled");
  }

  function generateSharedModal(discrepancy) {
    discrepanciesPhotoUploadModal = $(render(
      modalHtml,
      {
        title: ' Upload Photo',
        leftAlignTitle: true,
        body: uploadDiscrepanciesPhotoModalBodyHtml,
        modalDialogClass: "q-modal-dialog-800",
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
        <a  href="#" class="base-btn purple-btn custom-submit-btn upload-selected-photos disabled">Upload Selected</a>
        `
      }
    ));
    $("body").append(discrepanciesPhotoUploadModal);

    let photosUploader = new photoUploader({
      target: '.discrepancies-photos-uploader-body',
      accept: ['.jpg', '.jpeg'],
      multiple: true,
      maxFileSize: 0.5,
      afterValidSelection: function () {
        discrepanciesPhotoUploadModal.find(".upload-selected-photos").removeClass("disabled");
      },
      afterInvalidSelection: function () {
        discrepanciesPhotoUploadModal.find(".upload-selected-photos").addClass("disabled");
      }
    });

    photosUploader.init();
    discrepanciesPhotoUploadModal.modal("show");

    if (shallAllowClick(this)) {
      $(".upload-selected-photos").on('click', () => {
        submitModalFlow.showLoadingModal();
        uploadPhotos(photosUploader.getFiles(), discrepancy);
      });
    }
    discrepanciesPhotoUploadModal.on('hidden.bs.modal', function (e) {
      discrepanciesPhotoUploadModal.remove();
    });
  }

  function uploadPhotosuccess(resp) {
    if ($.trim(resp) == "true") {
      discrepanciesPhotoUploadModal.modal("hide");
      submitModalFlow.showSuccessModal();
      setTimeout(function () {
        location.href = "";
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    } else {
      uploadPhotosError();
    }
  }

  function uploadPhotosError() {
    submitModalFlow.hideAllModals();
    discrepanciesPhotoUploadModal.find(".upload-error").show();
  }

  function uploadPhotos(photosList, discrepancy) {

    let trackingNumber = discrepancy.redTrackingNum;
    let discrepancyCode = discrepancy.rddDiscrepancyCode;
    let redId = discrepancy.redId;
    let rddId = discrepancy.rddId;
    discrepanciesPhotoUploadModal.modal("hide");
    let formData = new FormData();
    photosList.forEach(file => { formData.append("files[]", file) });
    let photosuploadUrl = `${uploadPhotosUrl}&trackingNumber=${trackingNumber}&discrepancyCode=${discrepancyCode}&redId=${redId}&rddId=${rddId}`;
    $.ajax({
      url: photosuploadUrl,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      cache: false,
      success: uploadPhotosuccess,
      error: uploadPhotosError
    });
  }

  //Generate popup if user trying to delete record
  function generateDeleteWarningModal(redId, discrepancyCode) {
    deleteDiscrepanciesModal = $(render(
      modalHtml,
      {
        title: 'Are you sure you want to delete this discrepancy record',
        body: deleteDiscrepanciesModalBodyHtml,
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-800",
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
          <a  href="#" class="base-btn purple-btn custom-submit-btn delete-selected-discrepancy">Delete</a>
          `
      }
    ));

    $("body").append(deleteDiscrepanciesModal);

    deleteDiscrepanciesModal.modal("show");
    deleteDiscrepanciesModal.on('hidden.bs.modal', function (e) {
      deleteDiscrepanciesModal.remove();
    });

    //click on delete action in lookup event
    $('body').on('click', '.delete-selected-discrepancy', function (e) {
      e.preventDefault();
      location.href = `${deleteDiscrepancyUrl}&${portletNamespace}redId=${redId}&discrepancyCode=${discrepancyCode}`;
    });
  }

  //Generate popup if user trying to update record, which is already resolved
  function generateWarningModal(displayMessage) {
    resolvedDiscrepanciesModal = $(render(
      modalHtml,
      {
        title: displayMessage,
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-800",
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Ok</a>
          `
      }
    ));

    $("body").append(resolvedDiscrepanciesModal);

    resolvedDiscrepanciesModal.modal("show");
    resolvedDiscrepanciesModal.on('hidden.bs.modal', function (e) {
      resolvedDiscrepanciesModal.remove();
    });
  }

  //click on upload photo action in lookup event
  $('body').on('click', '.upload-photos', function (e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let discrepancy = row.data();
      //let row = table.row(parent);

      if (isPresent(discrepancy.redDateResolved)) {
        $(".upload-photos").prop("disabled", true);
        generateWarningModal(disabledImageResolvedMessage);
        $(".upload-photos").prop("disabled", false);
        return;
      }

      if (discrepancy.redRecordType === 'D') {
        $(".upload-photos").prop("disabled", true);
        generateWarningModal(disabledImageDeletedMessage);
        $(".upload-photos").prop("disabled", false);
        return;
      }

      generateSharedModal(discrepancy);
    }
  });

  //On click of Edit from the table view directly 
  $('body').on('click', '.edit-discrepancy', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    // Get the row based on the parent...
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = $(".data-table-component").dataTable().api().row(parent);
    let discrepancy = row.data();

    if (isPresent(discrepancy.redDateResolved)) {
      $(".edit-discrepancy").prop("disabled", true);
      generateWarningModal(editDisabledResolvedMessage);
      $(".edit-discrepancy").prop("disabled", false);
      return;
    }

    if (discrepancy.redRecordType === 'D') {
      $(".edit-discrepancy").prop("disabled", true);
      generateWarningModal(editDisabledDeleteMessage);
      $(".edit-discrepancy").prop("disabled", false);
      return;
    }

    var disabledFlag = 0;
    var createdDate = new Date(discrepancy.redCreatedTime);
    var currentDate = new Date();
    var cutOffDate = getCutOffDate(createdDate);

    if ((discrepancy.redDataFtp) && (currentDate.getTime() >= cutOffDate.getTime() ||
      currentDate.getTime() < createdDate.getTime())) {
      disabledFlag = 1;
    }

    location.href = `${getEditRecordURL}&${portletNamespace}redId=${discrepancy.redId}&disabledFlag=${disabledFlag}`;
  });

  //On click of Edit from the table view directly 
  $('body').on('click', '.delete-record', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    let row = $(".data-table-component").dataTable().api().row(parent);
    let discrepancy = row.data();

    if (isPresent(discrepancy.redDateResolved)) {
      $(".delete-discrepancy").prop("disabled", true);
      generateWarningModal(disabledDeleteResolvedMessage);
      $(".delete-discrepancy").prop("disabled", false);
      return;
    }

    if (discrepancy.redRecordType === 'D') {
      $(".delete-discrepancy").prop("disabled", true);
      generateWarningModal(disabledDeleteMessage);
      $(".delete-discrepancy").prop("disabled", false);
      return;
    }

    var createdDate = new Date(discrepancy.redCreatedTime);
    var currentDate = new Date();
    var cutOffDate = getCutOffDate(createdDate);

    if (currentDate.getTime() >= cutOffDate.getTime() || currentDate.getTime() < createdDate.getTime()) {
      $(".delete-discrepancy").prop("disabled", true);
      generateWarningModal(disabledDeleteCutOffMessage);
      $(".delete-discrepancy").prop("disabled", false);
      return;
    }

    generateDeleteWarningModal(discrepancy.redId, discrepancy.rddDiscrepancyCode);
  });

  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(actionCellDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row),
      index: meta.row
    });
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionList["all"];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(actionHeaderDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row)
    });
    return newRender;
  }

  function renderActionCellList(list, data, row) {
    let renderedList = _(list).map(item => {
      return render(
        actionCellDropdownItemTemplate,
        neededActions(data, row, item)
      );
    });
    return renderedList.join("");
  }

  function neededActions(data, row, item) {
    let action = {
      icon: item.icon,
      title: item.title,
      cls: item.cls,
      disabled: item.disabled
    };
    return action;
  }

  function getCutOffDate(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    var createdDay = new Date(date).getDay();
    var createdDate = new Date(date).getDate();
    var createdTime = new Date(date).getTime();
    var cutOffDate;

    //for saturday , it should go in else loop
    if (createdDay !== 6) {
      cutOffDate = new Date(createdTime + (6 - createdDay) * 1000 * 60 * 60 * 24 + 1000 * 60 * 60 * 11);
    } else {
      cutOffDate = new Date(createdTime + (13 - createdDay) * 1000 * 60 * 60 * 24 + 1000 * 60 * 60 * 11);
    }

    if (cutOffDate.getMonth() > date.getMonth()) {
      var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime();
      cutOffDate = new Date(lastDayOfMonth + 1000 * 60 * 60 * 11);
    }

    return cutOffDate;
  }

  function initExport() {
    let exportObj = {
      title: $(targetSelector).data("export-popup-title"),
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent(portletNamespace);
  }

  function setExportData(currentData) {
    exportModal.buildExportBasicURL(exportUrl, currentData, portletNamespace);
    exportModal.setExportCount(currentData.totalElements);
  }

  initExport();
  setExportData(receivingDiscrepanciesLookup.generateData());

  handleCustomDropdownEvents();

  $("th.dtc-action-column").html(renderActionHeaderWrap());

});


// WEBPACK FOOTER //
// ./src/pages/receivingDiscrepancies/lookup.js